export default {
  numberOfActivePostmen: state => state.activePostmen.length,
}